export default {
  whatSearch: 'What are you looking for?',
  products: 'Products',
  filtersBy: 'Filter by',
  delete: 'Cancel',
  popularSearch: 'Popular Searches',
}
